<div class="bonusDialog">
  <!--hier keine *appApplyIfNotEmpty-Directive, weil translationService.getTranslation() nur einen Teil des Contents darstellt - h2-Tag wird also nicht leer bleiben--->
  <h2
    mat-dialog-title>{{ bonus.name }}{{ (showBonusPoints) ? ' - ' + bonus.bonusValue + ' ' + translationService.getTranslation('order_bonusPoints') : '' }}</h2>
  <mat-dialog-content class="mat-typography">
    <img *ngIf="bonus?.image?.src"
         [ngSrc]="bonus.image?.src"
         [width]="imageService.width"
         [height]="imageService.height"
         [alt]="bonus.image?.altText"
         class="bonusImg my-3" fitImage>
    <p *ngIf="!bonus.descriptionFromDocument" [innerHTML]="bonus.description"></p>
    <p *ngIf="bonus.descriptionFromDocument" [innerHTML]="bonus.descriptionFromDocument"></p>

    <p *ngIf="bonus.clientCoPayment > 0" [innerHTML]="translationService.getTranslation('order_adjustment') + ' ' + bonus.clientCoPayment + ' ' + bonus.isoCurrencyCode">
      <br/>
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button mat-raised-button color="primary" mat-dialog-close="" data-cy="btn-bonus-details.close"
            [innerHTML]="translationService.getTranslation('button_close')"></button>
  </mat-dialog-actions>
</div>
